import { render, staticRenderFns } from "./Move.vue?vue&type=template&id=3c2f339a"
import script from "./Move.vue?vue&type=script&lang=js"
export * from "./Move.vue?vue&type=script&lang=js"
import style0 from "./Move.vue?vue&type=style&index=0&id=3c2f339a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports